import HttpClient from "./HttpClient";

export const PlaceService = {
    getPlaceById: async () => {
        const res = await new HttpClient().get(`places/info`);
        if (res.status === 200) {
            return res?.data?.data;
        }
        return false;
    },
    getPlaceTicketByDate: async (params) => {
        const res = await new HttpClient().post(
            "/places/list-ticket-price-by-date",
            params
        );
        if (res?.status === 200) {
            return res.data ? res.data.data : [];
        }
        return [];
    },
    // Lấy danh sách giá vé theo range ngày
    getTicketPricesInDateRange: async ({
        start_date,
        end_date,
        type_price,
    }) => {
        const res = await new HttpClient().post(
            "/places/list-ticket-price-min-by-date-range",
            {
                sale_date_range: `${start_date} - ${end_date}`,
                type_price,
            }
        );
        if (res?.status === 200) {
            return res.data ? res.data.data : [];
        }
        return [];
    },
};
